import { render, staticRenderFns } from "./ChatInput.vue?vue&type=template&id=654aec2c&scoped=true"
import script from "./ChatInput.vue?vue&type=script&lang=js"
export * from "./ChatInput.vue?vue&type=script&lang=js"
import style0 from "./ChatInput.vue?vue&type=style&index=0&id=654aec2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../condounits/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654aec2c",
  null
  
)

export default component.exports